import { render, staticRenderFns } from "./OrdersGridItem.vue?vue&type=template&id=60f506c4&scoped=true"
import script from "./OrdersGridItem.vue?vue&type=script&lang=js"
export * from "./OrdersGridItem.vue?vue&type=script&lang=js"
import style0 from "./OrdersGridItem.vue?vue&type=style&index=0&id=60f506c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f506c4",
  null
  
)

export default component.exports